import { Editor } from '@tiptap/react';
import { type LucideIcon } from 'lucide-react';
import { cn } from '@/Domain/utils/cn';

type Props = {
  editor: Editor;
  action: () => void;
  isActive: boolean;
  icon: LucideIcon;
  label: string;
};

export const BubbleMenuButton = ({ action, isActive, icon: IconComponent, label }: Props) => (
  <button
    type="button"
    onClick={action}
    className={cn('rounded p-1 hover:bg-accent', isActive && 'bg-accent')}
    aria-label={label}
  >
    <IconComponent className="size-4" />
  </button>
);
